import * as Yup from "yup";
import checkout from "./form";

const {
  formField: {
    id,
    name,
    email,
    website,
    description,
    phoneNumber,
    shortNumber,
    logoUrl,
    enProfileUrl,
    arProfileUrl,
  },
} = checkout;

const validations = [
  Yup.object().shape({
    [name.name]: Yup.string().required(name.errorMsg),
    [email.name]: Yup.string().email().required(email.errorMsg),
    [website.name]: Yup.string().url().required(website.errorMsg),
    [description.name]: Yup.string().required(description.errorMsg),
    [phoneNumber.name]: Yup.string().required(phoneNumber.errorMsg),
    [shortNumber.name]: Yup.string().required(shortNumber.errorMsg),
  }),
];

export default validations;
